import React from 'react';
import '../WebflowCss/ark-payment.webflow.css';
import '../WebflowCss/normalize.css';
import '../WebflowCss/webflow.css';
import Logo from '../assets/images/Logo.svg';

export const Navbar = () => {
  return (
    <div className="navbar">
      <div className="presenter-container">
        <div className="logo-box">
          <img src={Logo} loading="lazy" alt="" className="navbar-logo" />
        </div>
      </div>
    </div>
  );
};
